import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './CustomerChoiceCompany.css';
import RadioButton from '../common/radioButton/RadioButton';
import RegulationAcceptance from '../regulationAcceptance/RegulationAcceptance';
import { useNavigate } from "react-router-dom";
import { getCustomer, setCustomerType } from "../../features/customer/customerSlice";
import { setComplaintType, setCreatedDate, setIsTermOfUseAccepted } from '../../features/complaint/ComplaintSlice';
import { getComplaint, setSelectClient, setSelectComplaintType } from "../../features/complaintTypes/ComplaintTypesSlice";   
import { setCompanyType } from '../../features/customer/companySlice';

import moment from 'moment';
import Modal from '../common/modal/Modal';
import { Dialog } from '../common/dialog/Dialog';

export const CustomerChoiceCompany = ({ isChoiceSelected,onChoiceCompanySelected,isChoiceCompanySelected }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const complaintTypes = useSelector((state) => state.complaintTypes.complaintTypes);
    const [selectedOption, setSelectedOption] = useState(null);
    const [currentPage, setCurrentPage] = useState(window.location.pathname);
    const isTermOfUseAccepted = useSelector((state) => state.complaint.isTermOfUseAccepted);
    const selectedClient = useSelector((state) => state.complaintTypes.selectedClient);
    const companyType = useSelector((state) => state.customer.type[0]);
    const transportDamage = useSelector((state)=>state.complaint.complaintType.name);
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    // const [isChoiceCompanySelected, setIsChoiceCompanySelected] = useState(false);

    useEffect(() => {
        dispatch(getComplaint());
        dispatch(getCustomer());

    }, [dispatch]);

    useEffect(() => {
        if (transportDamage === "TransportDamage") {
            setIsDialogOpen(true);
        }
    }, [transportDamage]);

    const closeDialog = () => {
        setIsDialogOpen(false);
    };

    const handleOptionClick = async (option) => {
          dispatch(getComplaint(option.name));
          setSelectedOption(option.displayName);
          setSelectClient(selectedClient);
          dispatch(setComplaintType({
            id: option.id,
            name: option.complaintType,
            displayName: option.displayName
          }));
         
          if (companyType) {
            dispatch(setCompanyType({
            
              id: companyType.customerId,
              displayName: companyType.displayName,
              customerType: companyType.customerType,
              description: companyType.description,
              value: companyType.name
            }));
        }
          if(!isChoiceCompanySelected){

              onChoiceCompanySelected("CustomerChoiceCompany");
          }
        dispatch(setCreatedDate(moment()));
      };

    useEffect(() => {
        function handlePageChange() {
            setCurrentPage(window.location.pathname);
        }
        window.addEventListener("popstate", handlePageChange);
        return () => {
            window.removeEventListener("popstate", handlePageChange);
        };
    }, [currentPage]);

    const handleFormSubmit = async (event) => {
        event.preventDefault();
    };

    const validateForm = () => {
        if (isTermOfUseAccepted && selectedOption) {
            setCurrentPage('companySearch');
            navigate('/companySearch');
        } else {
            console.error('error');
        }
    };

    const handleGetComplaintType = (event) => {
        const complaintType = event.target.value;
        dispatch(setSelectComplaintType(complaintType));
        dispatch(getComplaint(complaintType));
    };

    return (
        <div className='company-customer-container' onClick={handleGetComplaintType} onSubmit={handleFormSubmit}>
            <div className='company-customer-container-title-container'>
                <h5>firma</h5>
                <p style={{ fontSize: '14px', textTransform: 'none', fontWeight: 'normal' }}>(<span style={{color:"#EE2427"}}>Partner Handlowy firmy PRO Sp. z o.o.</span><br/> lub osoba prowadząca działalność gospodarczą)</p>
            </div>
            <div className='company-customer-type-list-container'>
                <p className='company-customer-type-list-container-title'>Możesz zgłosić:</p>
                <Dialog isOpen={isDialogOpen} onClose={closeDialog} hideCloseButton={true}>
                    <h4 style={{textAlign:'center', fontFamily:'Montserrat'}}>Procedura postępowania w przypadku zgłoszenia uszkodzenia transportowego przez Partnera Handlowego</h4>
                    <ol style={{fontFamily:'Montserrat'}}>
                        <li>Zgłoszenie elektroniczne przez Partnera Handlowego uszkodzenia transportowego musi zawierać:
                            <ul style={{listStyle:'none'}}>
                                <li>- protokół szkody spisany w obecności kuriera przy przyjęciu przesyłki</li>
                                <li>- dokumentację zdjęciową przesyłki i towarów uszkodzonych </li>
                            </ul>
                        </li><br/>
                        <li>Jeżeli w/w warunki nie zostaną spełnione przez Partnera Handlowego to zgłoszenie nie zostanie przyjęte do rozpatrzenia przez PRO Sp. z o.o.</li><br/>
                        <li>Partner Handlowy jest proszony o ew. zabezpieczenie nagrań z monitoringu z rozpakowania przesyłki o udostępnienie których może zostać poproszony do procedowania zgłoszenia uszkodzenia do przewoźnika.</li>
                    </ol>
                <button className="dialog-confirm-btn" onClick={closeDialog}>
                    Zapoznałem/am się
                </button>
                </Dialog>
                {Object.values(complaintTypes).filter(customer => customer.customerId === 2)
                    .map(customer => 
                        customer.complaintTypes.map(option => (
                            <li key={option.id} style={{listStyle:'none', cursor:'pointer', display:'inline-flex'}}>
                                <RadioButton
                                    id={option.id}
                                    name={option.name}
                                    value={option.displayName}
                                    onClick={() => handleOptionClick(option)}
                                    checked={selectedOption === option.displayName && !isChoiceSelected}
                                />
                                <p className="company-customer-list-element-text" onClick={() => handleOptionClick(option)}>
                                    {option.displayName}
                                </p>
                            </li>
                        ))
                    )
                }
                {selectedOption && !isChoiceSelected &&
                    <div>
                        <RegulationAcceptance checked={isTermOfUseAccepted} selectedOption={selectedOption} complaintTypes={complaintTypes} selectedClient={selectedClient}/>
                        <button className="add-complaint-btn" type="submit" onClick={validateForm}><p>Dodaj zgłoszenie</p></button>
                    </div>
                    }


            </div>
        </div>
     )
}
